var _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSlipAndFall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 39,
    viewBox: "0 0 38 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.2797 11.2008V4.55078H17.6697V9.47457L14.6297 12.3408L9.49966 14.0508L6.64966 19.7508V25.4508H10.1647V20.7008L11.4749 18.0804L13.0755 20.4814L13.0714 20.4841L15.7305 24.4994V24.5008H15.7314H22.7999L29.4499 30.2008L31.9199 27.3508L23.7499 20.7008H20.9798L20.9492 20.6548L24.6997 16.9037H33.2501L33.2497 13.2939L23.4647 13.2937L19.4257 17.0316L17.4906 14.7094L21.2797 11.2008ZM15.1173 8.97462C15.1173 10.8932 13.5621 12.4485 11.6435 12.4485C9.72495 12.4485 8.16966 10.8932 8.16966 8.97462C8.16966 7.05607 9.72495 5.50078 11.6435 5.50078C13.5621 5.50078 15.1173 7.05607 15.1173 8.97462Z",
    fill: "#CCCFD1"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.80005,
    y: 31.1504,
    width: 30.4,
    height: 3.47384,
    fill: "#CCCFD1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSlipAndFall);
export default __webpack_public_path__ + "static/media/icon-slip-and-fall.11cb95956ba2bd223d77fb04c4a48874.svg";
export { ForwardRef as ReactComponent };